import { CompanyEntity } from '../common/entity';
import { EntityAuthorization } from '../common/entityAuthorization';
import { CompanyRole } from '../company_role_assignment/companyRoleAssignment';
import { EntityType } from '../comment';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';

export class AssetLocation {
  entityId: string;
  entityType: EntityType;

  constructor(entityId: string, entityType: EntityType) {
    this.entityId = entityId;
    this.entityType = entityType;
  }
}

export class AssetProduct {
  productMasterDataId!: string;
  serial?: string;
  unitQuantity!: string;
  quantity!: number;

  // Web only
  reservedUnitQuantity: string = '0';
  reservedQuantity: number = 0;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export class Asset extends CompanyEntity {
  location?: AssetLocation;
  product!: AssetProduct;
  identifier?: string;

  authorization = new AssetAuthorization();

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
    this.product = new AssetProduct(this.product);
  }
}

export class AssetAuthorization extends EntityAuthorization<Asset> {
  forCreate = () => CompanyRole.administrator;
  forUpdate = () => CompanyRole.administrator;
  forDelete = () => CompanyRole.administrator;
  forGet = () => CompanyRole.employee;
}

export interface AssetProduct extends WithCustomFields {}
applyMixins(AssetProduct, [AssetProduct, WithCustomFields]);
